import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
    icon?: React.ReactNode;
    title: string;
    description?: string;
    actions?: React.ReactNode;
    /** Renders a leading back button when provided. */
    onBack?: () => void;
    className?: string;
}

export function PageHeader({
    icon,
    title,
    description,
    actions,
    onBack,
    className,
}: PageHeaderProps) {
    return (
        <div
            className={cn(
                'flex flex-col gap-3 border-b border-border pb-4 sm:flex-row sm:items-center sm:justify-between',
                className,
            )}
        >
            <div className="flex items-center gap-3 min-w-0">
                {onBack && (
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={onBack}
                        className="h-9 w-9 shrink-0"
                        aria-label="Go back"
                    >
                        <ArrowLeft className="h-5 w-5" />
                    </Button>
                )}
                {icon && (
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-border bg-muted/50 text-primary">
                        {icon}
                    </div>
                )}
                <div className="min-w-0 space-y-0.5">
                    <h1 className="truncate text-lg font-semibold leading-none tracking-tight text-foreground sm:text-xl">
                        {title}
                    </h1>
                    {description && (
                        <p className="truncate text-sm text-muted-foreground">
                            {description}
                        </p>
                    )}
                </div>
            </div>
            {actions && <div className="shrink-0">{actions}</div>}
        </div>
    );
}
